var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RadioGroup',{attrs:{"disabled":_vm.isReadOnlyDialog,"required":"","items":[
    { data: { value: 'Yes', label: _vm.$t('wizer.common.yes') } },
    { data: { value: 'No', label: _vm.$t('wizer.common.no') } } ]}})}
var staticRenderFns = []

export { render, staticRenderFns }